import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store/store';
import type { OrderByCode, ServiceOrderItem } from '@/services/reparoly/ordersApi';

export type SelectedOrder = ServiceOrderItem | OrderByCode | null;

type SelectedOrderState = {
  order: SelectedOrder;
};

const initialState: SelectedOrderState = {
  order: null,
};

const selectedOrderSlice = createSlice({
  name: 'selectedOrder',
  initialState,
  reducers: {
    setSelectedOrder(state, action: PayloadAction<SelectedOrder>) {
      state.order = action.payload ?? null;
    },
    clearSelectedOrder(state) {
      state.order = null;
    },
  },
});

export const { setSelectedOrder, clearSelectedOrder } = selectedOrderSlice.actions;
export default selectedOrderSlice.reducer;

export const selectSelectedOrder = (state: RootState) => state.selectedOrder.order;

